import { render, staticRenderFns } from "./settingservice.vue?vue&type=template&id=4211289c&scoped=true&"
import script from "./settingservice.vue?vue&type=script&lang=js&"
export * from "./settingservice.vue?vue&type=script&lang=js&"
import style0 from "./settingservice.vue?vue&type=style&index=0&id=4211289c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4211289c",
  null
  
)

export default component.exports